<template>
  <div class="main">
    <AllHeader title="理事长简介"></AllHeader>
    <div class="wrapper">
      <div class="content" >
        <img :src="lszData.picture" alt="">
        <h2>{{lszData.fee}} : {{lszData.title}}</h2>
        <div class="show" v-html="lszData.detail"></div>
      </div>
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue";
import { getLsz } from "@/api/gywm.js";
import { BASE_URL } from "@/utils/base.js";
export default {
  data() {
    return {
      lszData:{}
    };
  },
  mounted() {
    // window.scrollTo(0, 0);
    this.getData()
  },
  methods: {
    async getData() {
      let news = new FormData();
      news.append("page", 1);
      news.append("rows", 100);
      news.append("dentity", "理事长");
      let note = await getLsz(news);
      this.lszData = note.rows[0]
      this.lszData.picture = BASE_URL + this.lszData.picture
    }
  },
  components: {
    AllHeader
  }
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 10px;
  width: 100%;
  .wrapper {
    width: 95%;
    margin: 40px auto;
    .content {
      img{
        width: 250px;
        height: 250px;
      }
      h2{
        font-size: 16px;
        font-weight: 600;
        margin: 20px 0 20px;
      }
      p{
        color: #ccc;
        font-size: 16px;
        line-height: 1.2;
      }
      .show{
        line-height: 2;
      }
    }
  }
}
</style>